<template>
  <div class="component">
    <div class="grid-container">
      <div class="week-day">Sun</div>
      <div class="week-day">Mon</div>
      <div class="week-day">Tue</div>
      <div class="week-day">Wed</div>
      <div class="week-day">Thu</div>
      <div class="week-day">Fri</div>
      <div class="week-day">Sat</div>
      <template v-if="firstDayOfMonth > 0">
        <div class="grid-item inactive" v-for="e in firstDayOfMonth" :key="e.e"></div>
      </template>

      <div class="grid-item" v-for="e in daysInMonth" :key="e">
        <template v-if="hasSpecial(dateString(e))">
          <tippy
            interactive
            :animate-fill="true"
            placement="bottom"
            distant="7"
            theme="light"
            animation="fade"
            trigger="mouseenter click"
            arrow
          >
            <template v-slot:trigger>
              <div class="day-number" :class="specialClass(dateString(e))">{{ e }}</div>
            </template>
            <div class="special_date">{{ month }} {{ e }}, {{ year }}</div>

            <!--/**  IS MOBILE */-->
            <badger-accordion
              :options="{ openHeadersOnLoad: [0] }"
              v-if="requiresAccordion(specialsToday(dateString(e)))"
            >
              <badger-accordion-item
                v-for="special in specialsToday(dateString(e))"
                v-bind:key="special.id"
                class="special"
              >
                <h2 slot="header">{{ special.title }}</h2>
                <div slot="content">
                  <p>{{ special.description }}</p>
                  <button @click="openChat(special.title)">Get this Offer!</button>
                </div>
              </badger-accordion-item>
            </badger-accordion>

            <!--/**  IS DESKTOP */-->
            <div
              v-for="special in specialsToday(dateString(e))"
              v-bind:key="special.id"
              class="special"
              v-else
            >
              <h2>{{ special.title }}</h2>
              <br />
              <p>{{ special.description }}</p>
              <button @click="openChat(special.title)">Get this Offer!</button>
              <!-- <div class="special_restriction">*restrictions apply</div> -->
            </div>
          </tippy>
        </template>

        <template v-else>
          <div class="day-number">{{ e }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { TippyComponent } from "vue-tippy";
import "tippy.js/themes/light.css";
import { BadgerAccordion, BadgerAccordionItem } from "vue-badger-accordion";
import { isMobile } from "mobile-device-detect";
import axios from "axios";

export default {
  name: "MonthlyCalendar",
  data() {
    return {
      today: moment(),
      dateContext: moment("2020-" + this.calMonth + "-01"),
      months: [
        { monthName: "January", monthNumber: "1" },
        { monthName: "February", monthNumber: "2" },
        { monthName: "March", monthNumber: "3" },
        { monthName: "April", monthNumber: "4" },
        { monthName: "May", monthNumber: "5" },
        { monthName: "June", monthNumber: "6" },
        { monthName: "July", monthNumber: "7" },
        { monthName: "August", monthNumber: "8" },
        { monthName: "September", monthNumber: "9" },
        { monthName: "October", monthNumber: "10" },
        { monthName: "November", monthNumber: "11" },
        { monthName: "December", monthNumber: "12" }
      ],

      currentSpecial: {}
    };
  },
  components: {
    tippy: TippyComponent,
    BadgerAccordion,
    BadgerAccordionItem
  },
  props: {
    calMonth: String,
    calData: Array
  },
  methods: {
    loadData() {
      // load a list of current guests / reservations
      axios
        .get(`https://playa-escondida.com/special-offers/specials.json`)
        .then(response => {
          this.specials = response.data;
         // console.log(this.specials);
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    moment: function() {
      return moment();
    },
    hasSpecial: function(currentDate) {
      
      var special = this.specials.some(el => el.date === currentDate);
      return special;
    },
    specialClass(currentDate) {
      var special = this.specials.filter(item => item.date === currentDate);

      if (special.length > 1) {
        return "sp_multiple";
      } else {
        return special[0].specialClass;
      }
    },
    specialTitle(currentDate) {
      var special = this.specials.find(item => item.date === currentDate);
      return special.title;
    },
    specialDescription(currentDate) {
      var special = this.specials.find(item => item.date === currentDate);
      return special.description;
    },
    specialsToday(currentDate) {
      var specials = this.specials.filter(item => item.date === currentDate);
      return specials;
    },
    pad(number, length) {
      var str = "" + number;
      while (str.length < length) {
        str = "0" + str;
      }
      return str;
    },
    dateString(e) {
      return this.year + "-" + this.pad(this.month, 2) + "-" + this.pad(e, 2);
    },
    openChat(special) {
      window.$zopim.livechat.window.show();
      window.$zopim.livechat.addTags(special);
      window.$zopim.livechat.say("I want to take the special offer");
    },
    requiresAccordion(specials) {
      //  console.log("specials", specials.length);
      // console.log(isMobile);
      if (specials.length > 1 && isMobile) {
        // console.log("Accordion should show");
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    year: function() {
      var t = this;
      return t.dateContext.format("Y");
    },
    month: function() {
      var t = this;
      return t.dateContext.format("MMMM");
    },
    calendarMonth: function() {
      return this.months[this.calMonth - 1].monthName;
    },
    daysInMonth: function() {
      var t = this;
      return t.dateContext.daysInMonth();
    },
    currentDate: function() {
      var t = this;
      return t.dateContext.get("date").format;
    },
    firstDayOfMonth: function() {
      var t = this;
      var firstDay = moment(t.dateContext).subtract(t.currentDate - 1, "days");
      return firstDay.weekday();
    },
    currentClass() {
      return this.currentSpecial.specialClass;
    },
    specials: function() {
      return this.calData;
    }
  },
  mounted() {
    //this.loadData();
    //console.log(this);
  }
};
</script>

<style>
* {
  font-family: "Open Sans", sans-serif;
}
h1 {
  line-height: 0;
  color: #424242;
  font-weight: 500;
  padding-left: 15px;
}
#specials-calendar {
  display: grid;
  grid-gap: 3px;
  background-color: #eeeeee;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  grid-gap: 0.5em;
  align-items: start;
}
/*#specials-calendar > div {
   padding: 10px;
}*/
.month {
  border: 1px solid #bdbdbd;
  /*height: 258px;*/
  margin: 3px;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 0px;
  background-color: #eeeeee;
}
.grid-item {
  position: relative;
  line-height: 2.3em;
  border: 1px solid #f5f5f5;
  background-color: #ffffff;
  padding: 0px;
  /*cursor: pointer*/
}
.tooltip {
  display: block !important;
  z-index: 10000;
  border-radius: 16px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.week-day {
  background-color: #df5b4c;
  line-height: 2em;
  text-align: center;
  color: white;
}
.grid-container {
  background-color: #f5f5f5;
}
.month_name {
  font-size: 3em;
}
.day-number {
  color: #757575;
  margin: 0;
  padding: 0;
  text-align: center;
  max-height: 200px;
  overflow: scroll;
}
.sp_orange {
  background-color: #dc8028;
  height: 100%;
  width: 100%;
  color: white;
  text-align: center;
}
.sp_blue {
  background-color: #049698;
  height: 100%;
  width: 100%;
  color: white;
}
.sp_green {
  background-color: #a0b351;
  color: white;
  height: 100%;
  width: 100%;
}
.sp_red {
  background-color: #df5b4c;
  color: white;
  height: 100%;
  width: 100%;
}
.sp_purple {
  background-color: #ce93d8;
  color: white;
  height: 100%;
  width: 100%;
}
.sp_multiple {
  color: white;
  /* background: -webkit-linear-gradient(110deg, #fdcd3b 60%, #ffed4b 60%);
  background: -o-linear-gradient(110deg, #fdcd3b 60%, #ffed4b 60%);
  background: -moz-linear-gradient(110deg, #fdcd3b 60%, #ffed4b 60%);
  background: linear-gradient(to right, #ce93d8 25%,#df5b4c 25%, #df5b4c 50%, #a0b351 50%, #a0b351 75%, #fdcd3b 75%);*/
  background: linear-gradient(45deg, #fdcd3b 50%, #ffed4b 50%);
}
.special {
  width: 350px;
  border: 1px solid silver;
  margin: -1px 0 0 -1px;
  margin-bottom: 10px;
  background-color: #f6f6f6;
}
.badger-accordion__header
  .js-badger-accordion-header
  .badger-accordion-toggle
  .badger-accordion-title {
  flex: 0 0 100%;
}
.badger-accordion-title > h2 {
  margin: 15px 0px;
  text-align: center;
  font-size: 1.9em;
}
/*.tippy-popper {
}*/
.component-badger-accordion {
  margin-top: 0px;
}
.badger-accordion__panel {
  background-color: #fff;
  margin: auto;
  margin-bottom: 10px;
  background-color: #f6f6f6;
  border: 1px solid silver;
  border-top: 0;
  border-width: 0px;
}
.badger-accordion--initialized .badger-accordion__panel {
  margin-top: -2px;
  margin-left: -1px;
  border-width: 1px;
}
.badger-accordion__panel p {
  width: 90%;
  margin: auto;
  text-align: center;
  margin: 20px;
}
.-ba-is-hidden {
  border: none;
}
.badger-accordion__header {
  border: 1px solid silver;
  margin: -1px 0 0 -1px;
  background-color: #f6f6f6;
}
.badger-accordion__panel button {
  background-color: #df5b4c;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  margin: 25px;
}
.badger-toggle-indicator {
  margin-left: -40px;
  font-size: 2em;
}

.special p {
  width: 90%;
  margin: auto;
}
.special > button {
  background-color: #df5b4c;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  margin: 25px;
}
.special_date {
  display: block;
  text-align: right;
  color: grey;
}
.special_restriction {
  text-align: right;
  width: 95%;
  font-style: italic;
  /* border: 1px solid; */
  margin-bottom: 10px;
}
* {
  outline: none;
}
</style>
